import React, { useState } from 'react';
import { auth } from '../firebase';
import { signInWithEmailAndPassword } from 'firebase/auth';
import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';

const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    try {
      await signInWithEmailAndPassword(auth, email, password);
      Swal.fire({
        icon: 'success',
        title: 'Login Berhasil',
        timer: 1500,
        showConfirmButton: false
      });
      navigate('/admin-ballaeja-secret');
    } catch (error) {
      Swal.fire({
        icon: 'error',
        title: 'Gagal Login',
        text: 'Email atau password salah.'
      });
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100 px-4">
      <div className="max-w-md w-full bg-white p-10 rounded-xl shadow-2xl">
        <h2 className="text-3xl font-serif font-bold text-center mb-8 text-gray-800">Admin <span className="text-red-600">Login</span></h2>
        <form onSubmit={handleLogin} className="space-y-6">
          <div>
            <label className="block text-xs font-bold uppercase tracking-widest text-gray-400 mb-2">Email Admin</label>
            <input 
              type="email" required 
              className="w-full p-4 bg-gray-50 border-b-2 border-transparent focus:border-red-600 outline-none transition-all"
              onChange={(e) => setEmail(e.target.value)}
            />
          </div>
          <div>
            <label className="block text-xs font-bold uppercase tracking-widest text-gray-400 mb-2">Password</label>
            <input 
              type="password" required 
              className="w-full p-4 bg-gray-50 border-b-2 border-transparent focus:border-red-600 outline-none transition-all"
              onChange={(e) => setPassword(e.target.value)}
            />
          </div>
          <button type="submit" className="w-full py-4 bg-red-600 text-white font-bold tracking-widest hover:bg-black transition-all">
            LOG IN
          </button>
        </form>
      </div>
    </div>
  );
};

export default Login;